import * as React from 'react';
import * as ReactDOM from 'react-dom';
const styles = require('./ShareClassSelector.pcss');

interface IShareClassSelectorState {
    visible: boolean;
}

export class ShareClassSelector extends React.Component<{}, IShareClassSelectorState>{

    constructor(props) {
        super(props);

        this.state = { visible: false };
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    toggleDropdown(event?) {
        event.stopPropagation();
        let currentVisibility = this.state.visible;
        this.setState({ visible: !currentVisibility }, () => {
            this.handleProps();
        });
    }

    componentWillMount() {
        this.handleProps();
    }

    handleProps() {
        if (this.state.visible) {
            this.addEvents();
        } else {
            this.removeEvents();
        }
    }

    addEvents() {
        document.addEventListener('click', this.handleDocumentClick, true);
    }

    removeEvents() {
        document.removeEventListener('click', this.handleDocumentClick, true);
    }

    handleDocumentClick(e) {
        const container = ReactDOM.findDOMNode(this);

        if (container.contains(e.target) && container !== e.target) {
            return;
        }

        this.toggleDropdown(e);
    }

    render() {
        let visibility = this.state.visible ? styles.active : '',
            internalClasses = {
                dropdown: `${styles.dropdown} ${visibility}`,
                arrow: `${styles.arrow} ${visibility}`
            };

        return (
            <div className={styles.shareClass}>
                <label>Select a share class </label>

                <section>
                    <div className={styles.selector} onClick={this.toggleDropdown}>
                        USD S ACC
                        <span className={internalClasses.arrow}></span>
                    </div>

                    <section className={internalClasses.dropdown}>
                        <div className={styles.options}>
                            <div className={styles.search}>
                                <input type="text" />
                            </div>

                            <ul>
                                <li className={styles.shareClassOption + ' ' + styles.selected}>USD S ACC</li>
                                <li className={styles.shareClassOption}>USD S DIST</li>
                                <li className={styles.shareClassOption}>USD S BCC</li>
                                <li className={styles.shareClassOption}>EUR D DIST</li>
                                <li className={styles.shareClassOption}>EUR D ACC</li>
                            </ul>
                        </div>
                    </section>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/ShareClassSelector/ShareClassSelector.tsx